// Rolldown's CJS interop doesn't extract the default export from packages
// that use `exports.default = X` with `__esModule: true`. This wrapper
// handles both the Rollup/esbuild behavior (direct constructor) and the
// Rolldown behavior (wrapped object with .default property).
import _Spline from "typescript-cubic-spline"

const Spline: typeof _Spline =
	typeof _Spline === "function" ? _Spline : (_Spline as { default: typeof _Spline }).default

export default Spline
export type { default as SplineType } from "typescript-cubic-spline"
